import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';

const FormikSubmitErrorEffect = ({ callback }) => {
  const formik = useFormikContext();

  const effect = () => {
    if (formik.submitCount > 0 && !formik.isSubmitting && !formik.isValid) {
      callback(formik);
    }
  };
  useEffect(effect, [formik.submitCount, formik.isSubmitting]);

  return null;
};

FormikSubmitErrorEffect.propTypes = {
  callback: PropTypes.func
};
export default FormikSubmitErrorEffect;
